<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />
   <b-container fluid>
    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>Searches</strong>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button variant="outline-primary" size="sm" to="/pri-simulation" class="mx-2">
                <font-awesome-icon icon="plus" />
            </b-button>

            <b-button variant="outline-info" size="sm" @click="onRefreshData">
               <font-awesome-icon icon="sync" />
            </b-button>
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="searchesFilter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!searchesFilter" @click="searchesFilter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <b-table
      ref="table"
      id="my-table"
      table-class="tableClass"
      sticky-header="calc(100vh - 200px)"
      responsive="sm"
      :fields="onBoardingSearchFields"
      :busy="isLoading"
      :items="getOnBoardingSearchData"
      :sort-by.sync="searchesSortBy"
      :sort-desc.sync="searchesSortDesc"
      :per-page="searchesPerPage"
      :current-page="searchesCurrentPage"
      :filter="searchesFilter"
    >
    <template v-slot:cell(created_at)="data">
        {{age(data.item.created_at)}}
      </template>
      <template v-slot:cell(pri_overall_score)="data">
        <b-badge variant="danger">HIGH</b-badge>
        
      </template>
      <template v-slot:cell(status)="data">
        <span  v-if="data.item.status == 0"><b-badge variant="warning">Processing</b-badge>&nbsp;<b-spinner variant="warning" type="grow" label="Spinning"></b-spinner> </span>
        <span  v-else><b-badge variant="success">Complete</b-badge></span>
      </template>
    <template v-slot:cell(actions)="data">
        <b-button type="button" :to="'/pri-search/'+data.item.id" variant="primary"><font-awesome-icon icon="eye"></font-awesome-icon></b-button>
      </template>
      <!-- <template v-slot:table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template> -->

    </b-table>
    <!-- v-if="getOnBoardingSearchData.length" -->
    <b-row v-if="onBoardingSearchItems.length">
      <b-col cols="2">
        <b-form-select
          v-model="searchesPerPage"
          id="perpageSelect"
          size="sm"
          :options="searchesPageOptions"
        ></b-form-select>
      </b-col>
      <b-col class="text-right" cols="4">
    <p>Current Page: {{ searchesPerPage }} rows</p>
      </b-col>
      <b-col cols="6">
        <b-pagination
          class="float-right"
          v-model="searchesCurrentPage"
          :total-rows="searchesDataTotalRows"
          :per-page="searchesPerPage"
          first-text="First"
          prev-text="Prev"
          next-text="Next"
          last-text="Last"
          aria-controls="my-table"
        ></b-pagination>
      </b-col>
    </b-row>
    <p v-if="!onBoardingSearchItems.length">No data Available</p>
  </b-container>
  </div>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import moment from "moment";
import "moment/locale/es";
import AppLoader from "../components/Loader/Loader";

export default {
  name: "PriSearchesContainer",
  components: {
    AppLoader
  },
  data() {
    return {
      isLoading: false,
      searchestotalRows: 0,
      searchesFilter: null,
      searchesPerPage: 10,
      searchesCurrentPage: 1,
      searchesSortBy: "id",
      searchesSortDesc: true,
      searchesPageOptions: [5, 10, 25, 50, 100],
      onBoardingSearchFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "pri_type.name", label: "Pri Type", sortable: true },
        {
          key: "onboarding.vendor_edu.company_name",
          label: "Company Name",
          sortable: true
        },
        {
          key: "onboarding.shield_vendor.comp_name_eng",
          label: "Third Party",
          sortable: true
        },
        
        { key: "ibf_members.name", label: "Created By", sortable: false },
        { key: "pri_overall_score", label: "PRI", sortable: false },
        { key: "status", label: "Status", sortable: false },
        { key: "actions", label: "Action", sortable: false }
      ],
      onBoardingSearchItems: [],

    };
  },
  computed: {
    searchesDataTotalRows() {
      return this.searchestotalRows;
    }
  },
  mounted() {},
  methods: {
     age(value) {
      moment.locale("en");
      
      return moment.utc(value).fromNow();
    },
    onRefreshData(){
      this.$root.$emit("bv::refresh::table", "my-table");
      // this.getOnBoardingSearchData();
    },
    async getOnBoardingSearchData() {
      let formData = {
        userId: localStorage.getItem("userId"),
        filter: this.searchesFilter,
        sort:
          this.searchesSortBy +
          "|" +
          (this.searchesSortDesc == true ? "desc" : "asc"),
        per_page: this.searchesPerPage,
        page: this.searchesCurrentPage
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP("post", "v1/onboading/searches", formData, {
        Authorization: token
      });
      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.searchestotalRows = response.data.total;
          this.onBoardingSearchItems = response.data.data
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [error];
        });
    }
  }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

.table-col {
  /* max-height: calc(100vh - 140px); */
  /* overflow-y: scroll; */
}

.pagination {
  margin-top: 0;
}

.btn.btn-border {
  border: 1px solid;
  margin-right: 2px;
}

.vuetable-pagination-info {
  margin-top: 8px !important;
}

span.sort-icon {
  float: right;
  color: #ff9100;
}
.table-responsive-sm{
  /* height: calc(100vh - 140px) !important; */
  /* overflow-y: scroll !important */
}
</style>
